import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	showAllLayers: {
		id: 'eoc-schedule.ui.list.schedule.show-all-layers',
		defaultMessage: 'Show all layers',
		description: 'Button to show all layers of schedule.',
	},
	showLessLayers: {
		id: 'eoc-schedule.ui.list.schedule.show-less-layers',
		defaultMessage: 'Show less layers',
		description: 'Button to show less layers of schedule.',
	},
});
